define("Location.Collection.Extension", [
    "Location.Collection",
    "underscore",
    "Utils",
  ], function defineLocationCollectionExtension(LocationCollection, _, Utils) {
    "use strict";
  
    _.extend(LocationCollection.prototype, {
        update: function update(options, callbacks) {
        return this.fetch(
          _.extend(
            {
              data: {
                // @property {String} latitude
                latitude: options.latitude,
                // @property {String} longitude
                longitude: options.longitude,
                // @property {String} radius
                radius: options.radius,
                // @property {String} sort
                sort: options.sort,
                // @property {Number} page
                page: options.page,
                // @property {Number} locationtype
                locationtype: options.locationtype,
                // @property {Number} results_per_page
                results_per_page: 400,
              },
              reset: !!options.reset,
              killerId: options.killerId,
            },
            callbacks
          )
        );
      },
    });
  });
  
